import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";


export type Tag = {
  filterValue: string;
};

const listTags: Source<Tag[]> = {
  graphql: parse(`
    query listIRFilterLookups($nextToken: String) {
      listIRFilterLookups(
        limit: 10000,
        nextToken: $nextToken,
        filterAttribute: "tags",
        sortDirection: ASC
      ) {
        nextToken
        items {
          filterValue
        }
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.TAGS,
    // The lookup table partitions by the attribute being filtered on; tags are one
    // partition of it. No isActive here — these rows do not carry the flag.
    keyCondition: () => ({
      expression: "#filterAttribute = :filterAttribute",
      names: { "#filterAttribute": "filterAttribute" },
      values: { ":filterAttribute": "tags" },
    }),
    ascending: true,
  },
};

export const getTags = async (client: SchemaClient): Promise<Tag[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listTags);
};

export const getAndProcessTags = async (client: SchemaClient): Promise<Tag[]> => {
  const tags = await getTags(client);
  return tags?.map((tag) => ({
    filterValue: tag.filterValue,
  })) ?? [];
};
